<template>
  <div class="candidate-evaluation-buttons relative">
    <button
      class="button-match-action button-dislike"
      @click="match(MatchType.Dislike)"
    >
      <icon-reject class="text-4xl" />
    </button>
    <button
      class="button-match-action button-love"
      @click="match(MatchType.Love)"
    >
      <img
        v-if="colors"
        class="svg-icon text-4xl"
        src="@/assets/icons/genicon-icons8-heart-filled-outline.svg"
      />
      <icon-heart-empty v-else class="svg-icon text-4xl" />
    </button>
    <button
      class="button-match-action button-like"
      @click="match(MatchType.Like)"
    >
      <icon-accept class="text-4xl" />
    </button>
  </div>
</template>

<script>
import IconAccept from "@/components/icons/IconAccept";
import IconReject from "@/components/icons/IconReject";
import IconHeartEmpty from "@/components/icons/IconHeartEmpty";
import { MatchType } from "@/utils/MatchType";

export default {
  name: "EvaluationButtons",
  components: { IconHeartEmpty, IconReject, IconAccept },
  props: {
    candidate: {
      type: Object,
      required: true
    },
    colors: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      MatchType: MatchType
    };
  },
  methods: {
    match(type) {
      this.type = type;
      this.confidence = 1;
      this.confidenceOpacity = 1;
      this.$emit("match", type);
    }
  }
};
</script>

<style scoped>
.candidate-evaluation-buttons {
  width: 94%;
  height: 100%;
  margin: 0 auto;
}

.button-match-action {
  position: absolute;
  width: 2.6875rem;
  height: 2.6875rem;
}

.button-dislike {
  left: 0;
  bottom: 0.8rem;
}

.button-like {
  right: 0;
  bottom: 0.8rem;
}

.button-love {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@media screen and (min-width: 768px) {
  .candidate-evaluation-buttons {
    width: 78%;
  }
  .button-match-action {
    width: 3.1875rem;
    height: 3.1875rem;
  }
}
</style>
